/* TFPC v1.24: Shop Pay Installments on kit pages.
   The section renders Shopify's own <shopify-payment-terms> (from a real product form: real plans, limits, seller id).
   A kit is not a product, so this swaps the variant entry for one carrying the kit total, using the plan that covers it.
   Shopify's element does the wording, the maths it shows and the "Learn more" modal. Below the minimum: hidden. */
(function () {
  'use strict';
  function amt(el) { var n = parseFloat(String(el ? el.textContent : '').replace(/[^0-9.]/g, '')); return isFinite(n) ? n : 0; }
  function fmt(n) { return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function terms(plan) {
    var split = 0, any = 0;
    (plan.terms || []).forEach(function (t) { var c = +t.installments_count || 0; if (c > any) any = c; if (t.loan_type === 'split_pay' && c > split) split = c; });
    return split || any;
  }
  function update() {
    var total = amt(document.querySelector('[data-kit-total]'));
    document.querySelectorAll('[data-tfpc-inst]').forEach(function (box) {
      var el = box.querySelector('shopify-payment-terms'); if (!el) return;
      var meta; try { meta = JSON.parse(el.getAttribute('shopify-meta') || '{}'); } catch (e) { box.hidden = true; return; }
      if (!meta.financing_plans || !meta.variants || !meta.variants.length) { box.hidden = true; return; }
      var plan = meta.financing_plans.filter(function (p) { return total >= p.min_price_amount && total <= p.max_price_amount; })[0];
      var ok = !!plan && total >= (meta.min_price_amount || 0) && total <= (meta.max_price_amount || Infinity);
      if (!ok) { box.hidden = true; return; }
      var n = terms(plan) || 1, per = Math.floor(total * 100 / n) / 100;
      var v = meta.variants[0];
      meta.variants = [{ id: v.id, price_per_term: fmt(per), price_per_term_amount: per, full_price: fmt(total), full_price_amount: total, eligible: true, available: true, number_of_payment_terms: n }];
      var next = JSON.stringify(meta);
      if (next !== el.getAttribute('shopify-meta')) el.setAttribute('shopify-meta', next);
      box.hidden = false;
    });
  }
  function init() {
    update();
    var t = document.querySelector('[data-kit-total]');
    if (t && 'MutationObserver' in window) new MutationObserver(update).observe(t, { childList: true, characterData: true, subtree: true });
    document.addEventListener('tfpc:zone', function () { setTimeout(update, 0); });
  }
  // after tfpc.js has picked the plants for the shopper's zone (it runs on DOMContentLoaded too, registered first)
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
